import React from 'react';
import styled from 'styled-components';

// Change it to  styled component.

const InnerBox = styled.div.attrs({
  className: 'InnerBox',
  direction: props => props.direction,
  padding: props => props.padding || '14px 0'
})`
  display: flex;
  flex-direction: ${props => props.direction};
  width: 100%;
  justify-content: center;
  max-width: 1040px;
  box-sizing: border-box;
  padding: ${props => props.padding};
`;

const innerBox = props => {
  return (
    <InnerBox className={props.className} direction={props.direction}>
      {props.children}
    </InnerBox>
  );
};

export default innerBox;
